import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { darkTheme, lightTheme } from '../../settings/appStyle/theme';
import { GlobalStyles } from '../../settings/appStyle/global.style';
import { AppLayout } from './layout.style';
import { Navbar } from '../../modules/Navbar';
import { useAuth } from '../../hooks/useAuth';
import VerificationEmailModal from '../../modules/Navbar/modals/verificationEmailModal';

const RootLayout = () => {
  const [isDark, setIsDark] = useState(() => {
    const savedTheme = localStorage.getItem('theme');

    if (savedTheme) {
      return savedTheme === 'dark';
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  const [isVerifyModalOpen, setIsVerifyModalOpen] = useState(false);
  const { userData } = useAuth();

  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');

    document.documentElement.classList.toggle('dark', isDark);
  }, [isDark]);

  useEffect(() => {
    if (userData && !userData.emailVerified) {
      setIsVerifyModalOpen(true);
    }
  }, []);

  const toggleTheme = () => {
    setIsDark((prev) => !prev);
  };

  return (
    <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
      <GlobalStyles />

      <AppLayout>
        <Navbar isDark={isDark} toggleTheme={toggleTheme} />

        <Outlet context={{ isDark, toggleTheme }} />
      </AppLayout>

      <VerificationEmailModal
        isOpen={isVerifyModalOpen}
        onClose={() => setIsVerifyModalOpen(false)}
        email={userData?.email}
      />
    </ThemeProvider>
  );
};

export default RootLayout;
